import { render, staticRenderFns } from "./LeituraOperadora.vue?vue&type=template&id=d5bc0dfa&scoped=true&class=template&"
import script from "./LeituraOperadora.vue?vue&type=script&lang=js&"
export * from "./LeituraOperadora.vue?vue&type=script&lang=js&"
import style0 from "./LeituraOperadora.vue?vue&type=style&index=0&id=d5bc0dfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5bc0dfa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCol,VIcon,VRow})
